import {
  REQUEST_STATE_OPTIONS,
  RECEIVE_STATE_OPTIONS,
  STATE_OPTIONS_ERROR
} from '../actions/stateOptions'

const initialState = {
  isLoading: false,
  hasErrors: false,
  items: null
}
const stateOptions = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_STATE_OPTIONS:
      return Object.assign({}, state, {
        isLoading: true
      })
    case RECEIVE_STATE_OPTIONS:
      return Object.assign({}, state, {
        items: action.payload,
        isLoading: false,
        hasErrors: false
      })
    case STATE_OPTIONS_ERROR:
      return Object.assign({}, state, {
        hasErrors: true
      })
    default:
      return state
  }
}

export default stateOptions
